/* IE8 Dropdown width issue fix */
function SetWidthToAuto(drpLst) {
    drpLst.style.width = 'auto';
}